module.exports = __webpack_public_path__ + "img/img29.5a79352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img29.jpg
// module id = 295
// module chunks = 0